import Config from '../config/Config';

const Analytics = function(eventName, options) {
    const pixelTrack = function(eventName, options) {
        
    }
    return pixelTrack(eventName, options);
}

export default Analytics;